import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import icon1 from "../images/leaderboardIcons/leaderboard-icon1.png";
import icon2 from "../images/leaderboardIcons/leaderboard-icon2.png";
import icon3 from "../images/leaderboardIcons/leaderboard-icon3.png";
import icon4 from "../images/leaderboardIcons/leaderboard-icon4.png";
import icon5 from "../images/leaderboardIcons/leaderboard-icon5.png";
import icon6 from "../images/leaderboardIcons/leaderboard-icon6.png";
import icon7 from "../images/leaderboardIcons/leaderboard-icon7.png";
import icon8 from "../images/leaderboardIcons/leaderboard-icon8.png";
import icon9 from "../images/leaderboardIcons/leaderboard-icon9.png";
import icon10 from "../images/leaderboardIcons/leaderboard-icon10.png";
import logo from "../images/safety-hero-logo.png";
import { useGameStore } from "../store/gameStore";

// 더미 데이터 - 실제 서버 데이터를 시뮬레이션
const dummyRankings = [
  { rank: 1, name: "김준서", time: "51:13", icon: icon1 },
  { rank: 2, name: "서지우", time: "53:46", icon: icon2 },
  { rank: 3, name: "김은유", time: "55:06", icon: icon3 },
  { rank: 4, name: "박예은", time: "59:09", icon: icon4 },
  { rank: 5, name: "이지민", time: "61:33", icon: icon5 },
  { rank: 6, name: "이하윤", time: "64:52", icon: icon6 },
  { rank: 7, name: "박정휼", time: "67:38", icon: icon7 },
  { rank: 8, name: "최은우", time: "68:19", icon: icon8 },
  { rank: 9, name: "주시현", time: "71:42", icon: icon9 },
  { rank: 10, name: "임지후", time: "72:26", icon: icon10 },
];

const RankingBoard = () => {
  const navigate = useNavigate();
  const [rankings, setRankings] = useState([...dummyRankings]);
  
  // Zustand store에서 사용자 정보 가져오기
  const { userName, currentPlayTime, getFormattedPlayTime, isGameCompleted, getFinalPlayTime } = useGameStore();
  
  const [userRecord, setUserRecord] = useState({
    name: userName || "안전영웅",
    time: isGameCompleted ? getFinalPlayTime() : getFormattedPlayTime(),
    rank: null,
  });

  // 시간을 초 단위로 변환하는 함수
  const timeToSeconds = (timeStr) => {
    const [minutes, seconds] = timeStr.split(":").map(Number);
    return minutes * 60 + seconds;
  };

  // 사용자 기록을 순위에 반영하는 함수
  useEffect(() => {
    // 게임 완료된 경우 최종 시간, 아니면 현재 시간 사용
    const displayTime = isGameCompleted ? getFinalPlayTime() : getFormattedPlayTime();
    const currentName = userName || "안전영웅";
    
    setUserRecord({
      name: currentName,
      time: displayTime,
      rank: null,
    });

    // 게임이 완료된 경우에만 순위에 포함
    const hasValidRecord = isGameCompleted && displayTime !== "00:00" && timeToSeconds(displayTime) > 0;
    
    // 기존 순위와 사용자 기록을 합쳐서 정렬 (완료된 게임만 포함)
    const allRecords = [
      ...dummyRankings,
      ...(hasValidRecord ? [{ name: currentName, time: displayTime, icon: null }] : []),
    ].sort((a, b) => timeToSeconds(a.time) - timeToSeconds(b.time));

    // 새로운 순위 할당 - 각 순위마다 고유한 아이콘 할당
    const newRankings = allRecords.slice(0, 10).map((record, index) => {
      // 순위에 맞는 아이콘 배열
      const iconArray = [
        icon1,
        icon2,
        icon3,
        icon4,
        icon5,
        icon6,
        icon7,
        icon8,
        icon9,
        icon10,
      ];

      return {
        ...record,
        rank: index + 1,
        icon: iconArray[index],
      };
    });

    setRankings(newRankings);

    // 사용자의 새로운 순위 찾기 (유효한 기록이 있는 경우에만)
    const userNewRank = hasValidRecord 
      ? newRankings.find((record) => record.name === currentName)?.rank 
      : null;
    setUserRecord((prev) => ({ ...prev, rank: userNewRank }));
  }, [userName, currentPlayTime, getFormattedPlayTime, isGameCompleted, getFinalPlayTime]);

  const handleCertificateClick = () => {
    navigate("/certificate");
  };

  return (
    <div className="min-h-screen px-4 pt-2">
      <div className="max-w-4xl mx-auto">
        {/* 헤더 */}
        <div className="pl-5 py-4 flex justify-center items-center cursor-pointer" onClick={() => navigate("/")}>
          <img
            src={logo}
            alt="Safety Hero Logo"
            className="w-1/2 h-1/2 object-contain"
          />
        </div>

        {/* 돌아가기 버튼 */}
        <div className="flex justify-center mb-3">
          <button
            onClick={() => navigate("/")}
            className="w-full px-6 py-2 bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white font-bold rounded-xl shadow-lg transform transition-all duration-200 hover:scale-105 active:scale-95 flex items-center justify-center space-x-2"
          >
            <span className="text-lg">←</span>
            <span>돌아가기</span>
          </button>
        </div>

        {/* 나의 기록 섹션 */}
        <div className="bg-white rounded-2xl shadow-lg px-5 py-2 mb-3 border-2 border-indigo-200">
          <h2 className="text-2xl font-bold text-indigo-700 mb-4 text-center">
            나의 기록
          </h2>
          <div className="flex items-center justify-center space-x-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-indigo-600">
                {userRecord.rank ? `#${userRecord.rank}` : "순위 외"}
              </div>
              <div className="text-sm text-gray-500">순위</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600">
                {userRecord.time}
              </div>
              <div className="text-sm text-gray-500">기록</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-700">
                {userRecord.name}
              </div>
              <div className="text-sm text-gray-500">이름</div>
            </div>
          </div>
        </div>

        {/* 전체 순위 섹션 */}
        <div className={`bg-white rounded-2xl shadow-lg px-5 py-4 mb-4 overflow-y-auto ${isGameCompleted ? 'max-h-[350px]' : 'max-h-[400px]'}`}>
          <h2 className="text-2xl font-bold mb-4 text-center">전체 순위</h2>
          <div className="space-y-3">
            {rankings.map((record) => (
              <div
                key={record.rank}
                className={`flex items-center p-2 rounded-xl transition-all duration-200 hover:shadow-md ${
                  record.name === userRecord.name
                    ? "bg-indigo-50 border-2 border-indigo-300"
                    : "bg-gray-100 border-2 border-gray-300 hover:bg-gray-200"
                }`}
              >
                {/* 순위 아이콘 */}
                <div className="w-16 h-16 mr-4 flex-shrink-0">
                  <img
                    src={record.icon}
                    alt={`${record.rank}위 아이콘`}
                    className="w-full h-full object-contain"
                  />
                </div>

                {/* 시간 기록 */}
                <div className="flex-1 text-center">
                  <span className="text-xl font-semibold text-gray-700">
                    {record.time}
                  </span>
                </div>

                {/* 이름 */}
                <div className="flex-1 text-center">
                  <span
                    className={`text-lg font-semibold ${
                      record.name === userRecord.name
                        ? "text-indigo-700 font-bold"
                        : "text-gray-700"
                    }`}
                  >
                    {record.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 인증서 페이지 이동 버튼 - 게임 완료 시에만 표시 */}
        {isGameCompleted && (
          <div className="text-center">
            <button
              onClick={handleCertificateClick}
              className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-bold py-3 px-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105"
            >
              ✉️ 인증서가 도착했어요!
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RankingBoard;